import { type IBanksPikContractSchema } from '../repositories/special-promos/entities/banks_pik_contract/BanksPikContractSchema';
import { type IBank } from '../types/bank';

export function prepareBanks(response: IBanksPikContractSchema[]): IBank[] {
  return response.map(contract => {
    return {
      amount: contract.amount,
      bankName: contract.bankName,
      icon: contract.icon,
      initialInstallment: contract.initialInstallment,
      licenseText: contract.licenseText,
      maxTerm: contract.maxTerm,
      rate: contract.rate,
    };
  });
}
